import { t } from "i18next";
import React from "react";
import MapsRoute from "../../../../../../component/maps/MapsRoute";
import { AutoComplete, Pagination, Skeleton } from "antd";
import { SearchIcon } from "../../../../../../asset";
import useDetailDAIntrip from "../detail-da-intrip.hooks";
import style from "../../../AllTrip/AllTripAdd.module.css";

const TabOrder = ({
  order,
  route,
  directions,
  depotLong,
  depotLat,
  skeleton,
  actionViewDetail,
}) => {
  const {
    search,
    listOrderTrip,
    card,
    pageMap,
    searchListOrder,
    selectListOrder,
    onChangeSearch,
    handlePaginationMap,
  } = useDetailDAIntrip();

  return (
    <div className="flex">
      <div className="gap-[40px] mb-[24px] w-full">
        {/* Tab Title */}
        <h3 className="font-roboto text-[18px] font-semibold mb-[1.5rem] mt-2 w-full ">
          {t("Order Detail")}
        </h3>

        {/* Content Tab */}
        <div className="flex w-full">
          {/* //one */}
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Trip Plan ID")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {order?.trip_plan_id ? order?.trip_plan_id : "-"}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Trip Name")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {order?.trip_name ? order?.trip_name : "-"}
              </h4>
            </div>
          </div>
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Plan Name")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {order?.plan_name ? order?.plan_name : "-"}
              </h4>
            </div>
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Trip Number (Optional)")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {order?.trip_number ? order?.trip_number : "-"}
              </h4>
            </div>
          </div>
          <div className="gap-[40px] mb-[24px]">
            <div className="w-[350px] mb-[24px]">
              <label className="font-roboto text-[14px] text-[#818181]">
                {t("Trip ID")}
              </label>
              <h4 className="font-roboto text-[20px] text-[#424242]">
                {order?.trip_id ? order?.trip_id : "-"}
              </h4>
            </div>
          </div>
        </div>

        {/* Maps */}
        {skeleton ? (
          <Skeleton active />
        ) : (
          <div className="w-full mb-[50px]">
            <MapsRoute
              data={route}
              datas={card[pageMap - 1]}
              directions={directions}
              paging={pageMap}
              long={
                pageMap === 1
                  ? Number(depotLong)
                  : Number(
                      card[pageMap - 2][card[pageMap - 2]?.length - 1].longitude
                    )
              }
              lat={
                pageMap === 1
                  ? Number(depotLat)
                  : Number(
                      card[pageMap - 2][card[pageMap - 2]?.length - 1].latitude
                    )
              }
            />
            <div id={"pageMap"} className={style.Wrap + " justify-end flex"}>
              <div className="font-semibold text-base text-[#1D1D1D]">
                {card[pageMap - 1]?.length} Of {route?.length} Order
              </div>
              <Pagination
                onShowSizeChange={false}
                size="small"
                current={pageMap}
                defaultCurrent={pageMap}
                pageSize={25}
                total={route?.length}
                onChange={(value) => handlePaginationMap(value, 25)}
              />
            </div>
          </div>
        )}

        {/* Tab Sub Title */}
        <h3 className="font-roboto text-[18px] font-semibold mb-[1.5rem] mt-2 w-[31.25rem">
          {t("List Order")}
        </h3>

        {/* Content 2 */}
        <div className="grid grid-cols-2 gap-8 mt-4">
          <AutoComplete
            className="w-full"
            size="large"
            placeholder="Search order code"
            suffixIcon={<img src={SearchIcon} alt="search-icon" />}
            onSearch={(evt) => searchListOrder(evt)}
            allowClear
            options={search}
            onSelect={selectListOrder}
            onChange={(evt) => {
              onChangeSearch(evt);
            }}
          />
        </div>

        <div className="grid grid-cols-2 gap-8 mt-8 max-h-[35.875rem] overflow-auto">
          {listOrderTrip.length > 0
            ? listOrderTrip.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="grid grid-rows-2 w-full h-[5.25rem] rounded-md py-[1rem] px-[0.5rem] shadow-lg"
                  >
                    <p className="font-roboto font-medium text-lg text-gray-100">
                      {`Order ${item.order_id} - ${item.first_name} ${item.last_name}`}
                    </p>
                    <div className="grid grid-cols-2">
                      <div className="col-start-1 col-end-3 ">
                        <p className="font-roboto font-medium text-xl text-black-300">
                          {`${item.district} - ${item.sub_district}`}
                        </p>
                      </div>
                      <div
                        className="col-end-7 col-span-2 cursor-pointer"
                        onClick={() => actionViewDetail(item.id)}
                      >
                        <p className="font-roboto font-medium text-sm text-red-100">
                          View Detail
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default TabOrder;
